import HARDCODE from "../../business-const/HardCode/HardCode"

const tipoPatrimonioImobilizadoList = [
    {
        id: 10,
        descricao: 'Imóvel', // 'Imóvel Urbano',
        ordem: 10,
        //informaTipoFinalidadePatrimonioImobilizado: 'S',
        informaAluguel: 'S',
        //informaTipoImovel: 'S',
        informaUfItcmd: 'S',
        informaTipoEmpresaTipoRegimeTributario: 'N',
        tipoAgrupamento: HARDCODE.tipoAgrupamentoPatrimonioImobilizadoBensMoveisImoveis,
        help: '',
    },
    {
        id: 20, // HARDCODE.idTipoPatrimonioImobilizadoVeiculos
        descricao: 'Veículos', // 'Bens Móveis',
        ordem: 20,
        //informaTipoFinalidadePatrimonioImobilizado: 'S',
        informaAluguel: 'N',
        //informaTipoImovel: 'N',
        informaUfItcmd: 'S',
        informaTipoEmpresaTipoRegimeTributario: 'N',
        tipoAgrupamento: HARDCODE.tipoAgrupamentoPatrimonioImobilizadoBensMoveisImoveis,
        help: 'Informa aqui o valor de veículos, tratores, etc.',
    },
    {
        id: 30,
        descricao: 'Negócios',
        ordem: 30,
        //informaTipoFinalidadePatrimonioImobilizado: 'N',
        informaAluguel: 'N',
        //informaTipoImovel: 'N',
        informaUfItcmd: 'S',
        informaTipoEmpresaTipoRegimeTributario: 'S',
        tipoAgrupamento: HARDCODE.tipoAgrupamentoPatrimonioImobilizadoNegocios,
        help: 'Informe o valuation da empresa em caso de sucessão.',
    },
    {
        id: 40,
        descricao: 'Direitos Autorais',
        ordem: 40,
        //informaTipoFinalidadePatrimonioImobilizado: 'S',
        informaAluguel: 'N',
        //informaTipoImovel: 'N',
        informaUfItcmd: 'S',
        informaTipoEmpresaTipoRegimeTributario: 'N',
        tipoAgrupamento: HARDCODE.tipoAgrupamentoPatrimonioImobilizadoNegocios,
        help: '',
    },
    //{
    //    id: 50,
    //    descricao: 'Consórcio',
    //    ordem: 50,
    //    //informaTipoFinalidadePatrimonioImobilizado: 'N',
    //    informaAluguel: 'N',
    //    //informaTipoImovel: 'N',
    //    informaUfItcmd: 'S',
    //    informaTipoEmpresaTipoRegimeTributario: 'N',
    //    tipoAgrupamento: ???,
    //    help: '',
    //},
    {
        id: 60,
        descricao: 'Terreno',
        ordem: 60,
        //informaTipoFinalidadePatrimonioImobilizado: 'S',
        informaAluguel: 'N',
        //informaTipoImovel: 'N',
        informaUfItcmd: 'S',
        informaTipoEmpresaTipoRegimeTributario: 'N',
        tipoAgrupamento: HARDCODE.tipoAgrupamentoPatrimonioImobilizadoBensMoveisImoveis,
        help: '',
    },
    {
        id: 70,
        descricao: 'Imóvel Rural',
        ordem: 15,
        //informaTipoFinalidadePatrimonioImobilizado: 'S',
        informaAluguel: 'N',
        //informaTipoImovel: 'N',
        informaUfItcmd: 'S',
        informaTipoEmpresaTipoRegimeTributario: 'N',
        tipoAgrupamento: HARDCODE.tipoAgrupamentoPatrimonioImobilizadoBensMoveisImoveis,
        help: 'Informe aqui o valor de fazendas, sítios, etc.',
    },
    {
        id: 90,
        descricao: 'Gado',
        ordem: 90,
        //informaTipoFinalidadePatrimonioImobilizado: 'S',
        informaAluguel: 'N',
        //informaTipoImovel: 'N',
        informaUfItcmd: 'S',
        informaTipoEmpresaTipoRegimeTributario: 'N',
        tipoAgrupamento: HARDCODE.tipoAgrupamentoPatrimonioImobilizadoNegocios,
        help: 'Informe aqui o valor do gado.',
    },
    {
        id: 900, // HARDCODE.idTipoPatrimonioImobilizadoOutros
        descricao: 'Outros',
        ordem: 900,
        //informaTipoFinalidadePatrimonioImobilizado: 'S',
        informaAluguel: 'N',
        //informaTipoImovel: 'N',
        informaUfItcmd: 'S',
        informaTipoEmpresaTipoRegimeTributario: 'N',
        tipoAgrupamento: HARDCODE.tipoAgrupamentoPatrimonioImobilizadoBensMoveisImoveis,
        help: '',
    },
]

export default tipoPatrimonioImobilizadoList